//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
export default {
  data: function data() {
    return {
      params: {
        direction: 'vertical',
        allowTouchMove: false,
        autoplay: true,
        loop: true,
        slidesPerView: 1,
        effect: 'coverflow',
        centeredSlides: true,
        // coverflowEffect: {
        //   rotate: 30,
        //   stretch: 10,
        //   depth: 10,
        //   modifier: 1,
        //   slideShadows: false,
        // },
        fadeEffect: {
          coverflowEffect: true
        }
      }
    };
  },
  components: {
    Avatar: Avatar
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var swiper1 = new Swiper('.marquee1', _this.params);
      var swiper2 = new Swiper('.marquee2', _this.params); // swiper2.$el.css({ opacity: 0.3 });

      return {
        swiper1: swiper1,
        swiper2: swiper2
      };
    });
  },
  methods: {
    // *显示昵称
    nickHidden: function nickHidden(nick) {
      return "".concat(nick.substring(0, 1), "* ");
    }
  }
};